module.exports = __webpack_public_path__ + "static/media/main idea.35f5eee3.mp3";